import styled, { css } from 'styled-components';
import { Flexer } from '@ontruck/orc';

const customScroll = () => css`
  &::-webkit-scrollbar {
    width: 8px !important;
    height: 8px !important;
    border-radius: 8px !important;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(148, 166, 184, 0.5);
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
  }
`;

const ContentStyled = styled(Flexer.Parent)`
  background: #fff;
  flex: 1;
  flex-direction: column;
  align-content: stretch;
  overflow: hidden;
  overflow-y: auto;
  height: 100%;
  ${customScroll}
`;

export default ContentStyled;
